<template>
  <div class="quotation-list">
    <div class="quotation-list__title">
      <h1 class="medium-title">All Campaign</h1>
      <label class="subhead">Campaign Quotation list</label>
    </div>
    <div class="quotation-list__header">
      <div class="quotation-list__header__left">
        <i class="adx-ic_search"></i>
        <input v-model="searchBoxValue" type="text" placeholder="Search campaign quotation">
      </div>
      <div class="quotation-list__header__right">
        <div class="quotation-list__header__right__sort">
          <div class="quotation-list__header__right__sort__label">Sort by:</div>
          <a-dropdown-sort class="quotation-list__header__right__sort__dropdown" :value.sync="selectedSortValue" :type="true" :options="sortOptions"></a-dropdown-sort>
        </div>
      </div>
    </div>
    <div class="quotation-list__table">
      <a-table text="Tooltip button" 
      :items.sync="tableData" 
      :loading.sync="isLoading" 
      :isEmpty.sync="isEmpty"
      @selected="selectedMenu" 
      @selectedRow="selectedRow">
      </a-table>
      <a-pagination v-if="!isLoading && !isEmpty" :selectedPage="selectedPage" :maxPage="maxPage" @change-page="selectPage"/>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/api'
import { restEdge } from "@/api/edgeUrls"
import { globalMixins } from '@/lib/mixins/globalMixins'
import { helpers } from '@/lib/validation/'

// import table from '@/components/Table'
import Pagination from '@/components/Pagination';

import { formatShortDate } from '@/lib/util';

import { ASelectDropdown, ALoadingPrimary, AModal, APagination, ATable } from "ui-kit-v1"

export default {
  name: 'adx-pricelist',
  components: {
    'a-table': ATable,
    // 'a-table': table,
    'a-pagination': APagination,
    'a-dropdown-sort': ASelectDropdown,
    'a-modal': AModal,
    'a-loading': ALoadingPrimary,
  },
  mixins: [ globalMixins ],
  props: {

  },
  data() {
    return {
      maxPage: 1,
      selectedPage: 1,
      isUserCs: true,
      isUserCommercial: false,
      item: null,
      isLoading: false,
      isEmpty: false,
      searchBoxValue: null,
      selectedSortValue: '-created',
      sortOptions: [
        {
          label: "Name",
          value: "name",
        },
        {
          label: "Last Added",
          value: "-created",
        },
        {
          label: "First Added",
          value: "created",
        },
        {
          label: "Higest Price",
          value: "-total_price",
        },
        {
          label: "Lowest Price",
          value: "total_price",
        },
      ],
      tableData: {
        head: [
          {
            title: "ID",
            type: "text",
            display: "display:none;"
          },
          {
            title: "NAME",
            type: "description",
          },
          {
            title: "BRAND",
            type: "text"
          },
          {
            title: "COMPANY",
            type: "text"
          },
          {
            title: "TOTAL PRICE",
            type: "money"
          },
          // {
          //   title: "QUOTATION STATUS",
          //   type: "statuslabel"
          // },
          {
            title: "DISCOUNT STATUS",
            type: "text"
          },
          {
            title: "",
            type: "text"
          },
        ],
        menu:[
          {
            "id": 0,
            "name": "View Detail",
            "value": "view_detail",
          },
          {
            "id": 1,
            "name": "Edit Quotation",
            "value": "edit",
          },
          {
            "id": 2,
            "name": "Print",
            "value": "print",
          },
          {
            "id": 3,
            "name": "Request Discount",
            "value": "request_discount",
          },
        ],
        body: []
      },
      tableIds: [],
    }
  },
  computed: {

  },
  watch: {
    searchBoxValue: helpers.debounce(function() {
      this.$nextTick(() => {
        this.loadData()
      })
    }, 500),
    selectedSortValue: function() {
      this.loadData()
    },
    selectedPage: function() {
      this.loadData()
    },
  },
  beforeCreate() {

  },
  created() {
    this.loadData()
  },
  beforeMount() {

  },
  mounted() {
    // this.isUserCs ? this.optionList : this.optionList = []
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async loadData() {
      this.isLoading = true
      this.isEmpty = false
      this.tableIds = []
      let params = {
        page: this.selectedPage,
        search: this.searchBoxValue,
        sort: this.selectedSortValue
      }

      const { data, status } = await api.get(restEdge.quotationList, { 
        params: params, 
        needToken: true, 
        useRestEdge: true 
      })

      if (status === 200) {
        this.tableData.body = await data.results.map(result => {
          this.tableIds.push(result.id)
          let statusDisplay = this.displayStatus(result.status);
          let brand = '-'
          let company_name = '-'
          if (result.client_profile_detail != null){
            brand = result.client_profile_detail.brand
            company_name = result.client_profile_detail.company_name
          }
          let returnValues = {
            values: [
              { value: result.id, display: "display:none;"},
              { header: true, 
                items:[
                  { value: result.name},
                  // { value: result.owner_email}
                ]
              },
              { value: brand},
              { value: company_name},
              { value: result.total_price},
              // { value: statusDisplay.value, label : statusDisplay.label},
              { value: '-'},
            ]
          }
          return returnValues
        })
        this.maxPage = data.maxPage
        if (!this.tableData.body.length) this.isEmpty = true
      } else {
        this.showNotificationAlert('Error', 'Ops, something went wrong.', 'danger')
      }

      this.isLoading = false
    },
    displayStatus(status){
      let value = status.toLowerCase()
      let res = []
      switch(value){
        case `wfa`:
          res = { id: 0, value: 'pending', label: 'WAITING FOR APPROVAL'}
          break
        case `approved`:
          res = { id: 1, value: 'done', label: 'APPROVED'}
          break
        case `rejected`:
          res = { id: 2, value: 'no', label: 'REJECTED'}
          break
      }
      return res
    },
    async selectedRow(item, index) {
      let id = this.tableIds[index]
      this.$router.push({ name: 'quotationsummary', params: {id: id} });
    },
    selectedMenu(event, index){
      let selectedValue = event.value
      let id = this.tableIds[index]
      switch(selectedValue){
        case `view_detail`:
          this.$router.push({ name: 'quotationsummary', params: {id: id} });
          break 
        case `edit`:
          this.$router.push({ name: 'quotationedit', params: {id: id} });
          break
        case `print`:
          console.log('print')
          break
        case `request_discount`:
          console.log('request discount')
          break
      }
    },
    selectPage(item) {
      this.selectedPage = item
    },
    
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>

</style>
<style lang="scss">
.quotation-list {
  .table table thead tr td {
    span{
      color: black !important;
      font-weight: 400 !important;
    }
  } 

  tbody {
    tr {
      cursor: pointer;
      td {
        .inputed-type{
          width: 140px !important;
        }
        .money {
          text-align: left !important;
          span{
            color: #ff2d55;
          }
        }

        .description{
          .label_hover{
            span{
              font-size: 15px;
            }
          }
        }

        input{
          border: 1px solid lightgray;
          border-radius: 4px;
          padding: 8px;
          margin-bottom: 8px;
          width: 140px;
          // max-width: 130px;
        }
      }
    }
  }
  
  .table table tbody tr td .description{
    div{
      span{
        color: #999999;
      }
    }
  }

  .status-label .label{
    margin: 0px !important;
  }

  .modal__content{
    width: 45%;
  }
}
</style>
